import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AuthModal from './components/AuthModal';
import PaymentModal from './components/PaymentModal';
import LandingPage from './components/LandingPage';
import TrackingInterface from './components/TrackingInterface';
import ProfilePage from './components/ProfilePage';
import CarrierCoveragePage from './components/CarrierCoveragePage';
import CarrierPage from './components/CarrierPage';
import ContainerPrefixPage from './components/ContainerPrefixPage';
import FAQPage from './components/FAQPage';
import DeveloperApiPage from './components/DeveloperApiPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/results" element={<TrackingInterface />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/carriers" element={<CarrierCoveragePage />} />
          <Route path="/carriers/:slug" element={<CarrierPage />} />
          <Route path="/container-prefixes" element={<ContainerPrefixPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/developers" element={<DeveloperApiPage />} />
        </Routes>
        {/* Global modals — rendered above all routes */}
        <AuthModal />
        <PaymentModal />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
